module.exports = __webpack_public_path__ + "static/complex-592a4a526b63e84de3cf2e98cbba639c.png";